var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15.4,
    viewBox: "0 0 15 15.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_posizione",
    "data-name": "icona posizione",
    transform: "translate(-121 -26.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_posizione-2",
    "data-name": "icona posizione",
    transform: "translate(74.92 27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_38",
    "data-name": "Tracciato 38",
    d: "M53.621,0A5.547,5.547,0,0,0,48.08,5.541a6.393,6.393,0,0,0,.47,2.133,8.936,8.936,0,0,0,.64,1.2l3.8,5.757a.723.723,0,0,0,1.263,0l3.8-5.757a8.9,8.9,0,0,0,.64-1.2,6.391,6.391,0,0,0,.47-2.133A5.547,5.547,0,0,0,53.621,0Zm4.47,7.421a8.188,8.188,0,0,1-.584,1.092l-3.8,5.757c-.075.114-.1.114-.174,0l-3.8-5.757a8.192,8.192,0,0,1-.584-1.092,5.8,5.8,0,0,1-.419-1.88,4.889,4.889,0,0,1,9.778,0A5.808,5.808,0,0,1,58.091,7.421Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_39",
    "data-name": "Tracciato 39",
    d: "M115.014,64.008a2.934,2.934,0,1,0,2.934,2.934A2.937,2.937,0,0,0,115.014,64.008Zm0,5.215a2.282,2.282,0,1,1,2.282-2.282A2.284,2.284,0,0,1,115.014,69.223Z",
    transform: "translate(-61.393 -61.4)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_763",
    "data-name": "Rettangolo 763",
    transform: "translate(121 27)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.412488fc797567993065cd15b97ede45.svg";
export { ForwardRef as ReactComponent };